<script>
	import { store } from "$lib/utilities/store";

	import LoginForm from "$lib/sections/Admin/LoginForm.svelte";
	import DashboardManagement from "$lib/sections/Admin/Dashboard/DashboardManagement.svelte";

	export let data;
	export let lang;

	$: uid = $store?.userProfile?.uid;

	$: dbGroup = uid ? data?.url?.searchParams?.get("dbGroup") : null;
</script>

{#if uid && dbGroup}
	<DashboardManagement {dbGroup} />
{:else}
	<LoginForm {data} {lang} /> <!-- acts as portal login / logout -->
{/if}
